// extracted by mini-css-extract-plugin
export default {"p_up":"BY","header":"CY","appear":"EY","p_up_enter":"FY","p_up_enter_a":"GY","p_up_enter_a_d":"HY","p_up_exit":"IY","p_up_exit_a":"JY","p_up_exit_a_d":"KY"};
    if(module.hot) {
      // 1743628928668
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  